import PressItem from './PressItem';
import Empty from '../Empty';
import isEmpty from 'lodash/isEmpty';
export default function Press({ press, news, isMobile = false }: any) {
    return (
        <>
            {!isEmpty(press) && press.map((pressItem) => <PressItem pressItem={pressItem.content} hasImg={true} key={pressItem.id} isMobile={isMobile} />)}
            {!isEmpty(news) && news.map((newItem) => <PressItem pressItem={newItem.content} key={newItem.id} isMobile={isMobile} />)}
            {isEmpty(press) && isEmpty(news) && <Empty isMobile={isMobile} />}
        </>
    );
}
